<h2 class="text-xl font-bold mb-4">Bildprüfung</h2>

<div class="mb-6">
  <h3 class="text-xl font-semibold mb-3">Bild angemessen</h3>
  <div class="ml-4">
    <h4 class="text-lg font-semibold text-green-600 flex items-center mb-2">
      <span class="mr-2">✅</span> Akzeptieren, wenn:
    </h4>
    <ul class="list-disc ml-6 space-y-2">
      <li>Das Bild thematisch zum Angebot passt und professionell wirkt.</li>
      <li>
        Keine Urheberrechtsverletzungen oder unangemessene Inhalte enthalten
        sind.
      </li>
    </ul>
  </div>
  <div class="ml-4 mt-4">
    <h4 class="text-lg font-semibold text-red-600 flex items-center mb-2">
      <span class="mr-2">❌</span> Ablehnen bzw. Änderung erforderlich, wenn:
    </h4>
    <ul class="list-disc ml-6 space-y-2">
      <li>Das Bild nicht zum Inhalt passt oder irreführend ist.</li>
      <li>Es Urheberrechtsprobleme geben könnte.</li>
      <li>Unpassende oder anstößige Inhalte gezeigt werden.</li>
    </ul>
  </div>
</div>

<div class="mb-6">
  <h3 class="text-xl font-semibold mb-3">Bildauflösung ausreichend</h3>
  <div class="ml-4">
    <h4 class="text-lg font-semibold text-green-600 flex items-center mb-2">
      <span class="mr-2">✅</span> Akzeptieren, wenn:
    </h4>
    <ul class="list-disc ml-6 space-y-2">
      <li>Die Bildqualität für die Darstellung ausreichend hoch ist.</li>
      <li>Texte oder Details auf dem Bild gut erkennbar sind.</li>
    </ul>
  </div>
  <div class="ml-4 mt-4">
    <h4 class="text-lg font-semibold text-red-600 flex items-center mb-2">
      <span class="mr-2">❌</span> Ablehnen bzw. Änderung erforderlich, wenn:
    </h4>
    <ul class="list-disc ml-6 space-y-2">
      <li>Das Bild zu pixelig oder unscharf ist.</li>
      <li>Wichtige Details nicht gut erkennbar sind.</li>
    </ul>
  </div>
</div>

<div class="mt-4 p-4 bg-blue-50 rounded-lg">
  <p class="flex items-center text-blue-800">
    <span class="mr-2">➡</span>
    <span class="font-semibold">Best Practice:</span>
    Falls das Bild abgelehnt wird, sollte eine Begründung eingegeben und ggf.
    eine Mindestanforderung für die Bildauflösung vorgeschlagen werden.
  </p>
</div>
